import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import {
  DEFAULT_CUT_OFF_HOUR,
  DEFAULT_CUT_OFF_MINUTE
} from 'constants/constant';

export const dateDiff =(checkIn, checkOut) =>{

  const checkInDateTime = moment(checkIn).tz(TIME_ZONE);
  const checkOutDateTime = moment(checkOut).tz(TIME_ZONE);

  if (!checkInDateTime.isValid() || !checkOutDateTime.isValid()) {
    return
  }

  if (checkOutDateTime.isSameOrBefore(checkInDateTime)) {
    return;
  }

  // Adjust for cutoff time (3:00 AM EST)
  const adjustForCutoff = (date) => {
    const d = date.clone();
    const isBeforeCutoff = d.hour() < DEFAULT_CUT_OFF_HOUR || 
      (d.hour() === DEFAULT_CUT_OFF_HOUR && d.minute() < DEFAULT_CUT_OFF_MINUTE);

    if (isBeforeCutoff) {
      d.subtract(1, 'day');
    }
    d.startOf('day');
    return d;
  };

  const adjustedCheckIn = adjustForCutoff(checkInDateTime);
  const adjustedCheckOut = adjustForCutoff(checkOutDateTime);

  const days = adjustedCheckOut.diff(adjustedCheckIn, 'days');
  return Math.max(days, 1);
}

export const filterNonEmpty = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== ""));


export const retry = async (fn, retries = 3, delay = 800) =>{
  try {
    return await fn();
  } catch (err) {
    if (retries <= 0) throw err;

    await new Promise(res => setTimeout(res, delay));
    return retry(fn, retries - 1, delay);
  }
}